import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
import { PitRequestCriteria } from "./pit-request-criteria";
/** Структура типового запроса данных с бэка */
let PitRequestBody = class PitRequestBody {
    constructor(fields) {
        /** Набор критериев для выборки */
        this._criteria = new PitRequestCriteria();
        if (fields)
            Object.assign(this, fields);
    }
    get presetViewItemId() {
        return this._presetViewItemId;
    }
    set presetViewItemId(value) {
        this._presetViewItemId = value;
    }
    get criteria() {
        return this._criteria;
    }
    set criteria(value) {
        this._criteria = value;
    }
    get budgetPeriod() {
        return this._budgetPeriod;
    }
    set budgetPeriod(value) {
        this._budgetPeriod = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "presetViewItemId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitRequestBody.prototype, "_presetViewItemId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "budgetPeriod", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitRequestBody.prototype, "_budgetPeriod", void 0);
tslib_1.__decorate([
    jsonMember({ name: "criteria", constructor: PitRequestCriteria, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", PitRequestCriteria)
], PitRequestBody.prototype, "_criteria", void 0);
PitRequestBody = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [Object])
], PitRequestBody);
export { PitRequestBody };
